import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var learnerCourseListRes;
export const learnerCourseListTodo = createAsyncThunk('learnerCourseList', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'learner/learner_course_list',
            data: {
                "user_id": val.user_id,
                "user_role": user_id.vrole_name,
                "training_type": val.training_type,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return learnerCourseListRes = res.data
    } catch (error) {
        return learnerCourseListRes = error.response.data
    }
})


const learnerCourseListSlice = createSlice({
    name: 'learnerCourseList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(learnerCourseListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('learnerCourseList', state.data)
            }
        });
        builder.addCase(learnerCourseListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default learnerCourseListSlice.reducer; 